import { render, staticRenderFns } from "./BtnInserirSubItemContrato.vue?vue&type=template&id=031a9925&"
import script from "./BtnInserirSubItemContrato.vue?vue&type=script&lang=js&"
export * from "./BtnInserirSubItemContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports